export enum EventDescriptors {
    TITLE = 'title',
    TITLE_STANDARD = 'title_standard',
    DESC = 'desc',
    DESC_TITLE = 'desc_title',
    DESC_STANDARD = 'desc_standard',
    TIPS = 'tips',
    TIPS_TITLE = 'tips_title',
    DEVICE_STATUS = 'device_status',
    DESC_THREAT = 'desc_threat',
    DESC_DEVICE = 'desc_device',
    MAIN_BUTTON = 'main_button',
    MAIN_LINK = 'main_link',
    ICON = 'icon',
    WHATTODO_TITLE = 'whatToDo_title',
    WHATTODO_TITLE_STANDARD = 'whatToDo_title_standard',
    WHATTODO_DESC = 'whatToDo_desc',
    ACTION_TITLE = 'action_title',
    TEXT = 'text',
    FUNCTION = 'funct',
    TYPE = 'type',
    CONDITION = 'condition',
    SECONDARY_BUTTON = 'secondary_button',
    LINK = 'link',
    TEXT_FIRST = 'text_first',
    TEXT_FIRST_ONE = 'text_first_one',
    TEXT_LAST = 'text_last',
    TEXT_NEXT = 'text_next',
    TEXT_CONGRATS = 'text_congrats',
    FILE_NAME = 'file_name',
    ACCESSED_FROM = 'accessed_from',
    VISITED_URL = 'visited_url',
    BLOCKED_URL = 'blocked_url',
    CLEAN_URL = 'clean_url',
    THREAT_NAME = 'threat_name',
    BLOCKED_APP = 'blocked_app',
    BLOCKED_FILE = 'blocked_file',
    BLOCKED_PROCESS = 'blocked_process',
    ATTACK_SOURCE = 'attack_source',
    DEVICE_NAME = 'device_name',
    DISPLAY_NAME = 'display_name',
    NAME = 'name',
    DOMAIN = 'domain',
    PORT = 'port',
    VERSION = 'version',
    PROTOCOL = 'protocol'
}

export enum EventTypes {
    CONDITIONAL = 'conditional',
    RECURSIVE = 'recursive',
    MULTIPLE_CONDITIONAL = 'multiple_conditional',
    GENERIC_THREAT = 'generic_threat',
    LINK = 'link'
}

export enum EventConditions {
    STATUS = 'status',
    THREAT_TYPE = 'threat_type',
    TARGETS = 'targets',
    THREATS = 'threats',
    TYPE = 'type',
    DESC_TYPE = 'descType',
}

export enum DeviceStatusIcons {
    ZERO = 0,
    ONE = 1,
    TWO = 2
}

export enum NotificationsFunctions {
    ANTITHEFT_COMMANDS = 'antitheft_commands',
    ANTITHEFT_MAP = 'antitheft_map',
    ANTITHEFT_WIPE = 'antitheft_wipe',
    ANTITHEFT_SNAP = 'antitheft_snap',
    ANTITHEFT_LOCK = 'antitheft_lock',
    ALLOW_ACCESS_PAGE = 'allow_access_page',
    DEVICE_VIEW = 'device_view',
    UPDATE_BOX = 'update_box',
    VULNERABILITY_VIEW = 'vulnerability_view',
    BLOCK_DEVICE = 'block_device',
    INSTALL_PROTECTION = 'install_protection',
    SCAN_DEVICE = 'scan_device',
    VIEW_EXCEPTIONS = 'view_exceptions'
}

export enum NotificationsTypes {
    MALICIOUS_HOST = 'malicious_host',
    SUBSCRIPTIONS = 'subscriptions',
    REFERRAL_REWARD_APPLIED = 'referral_reward_applied',
    ISSUES = 'issues',
    PARENTAL = 'parental',
    NCC = 'ncc',
    NETWORK_ATTACK = 'network_attack',
    BOXSE_UPDATE = 'boxse_update',
    BOX_UPDATE = 'box_update',
    BOXSE_NEW_DEVICE = 'boxse_new_device',
    CL_EXPLOIT = 'cl_exploit',
    CL_ATTACK = 'cl_attack',
    CL_PRIVACY = 'cl_privacy',
    CL_TROJAN = 'cl_trojan',
    CL_BOT = 'cl_bot',
    ANTITHEFT = 'antitheft',
    WEB_ALERT = 'web_alert',
    DANGEROUS_URL = 'dangerous_url',
    BOXSE_DHCP_NOTIFICATION = 'boxse_dhcp_notification',
    NETWORK_UPDATE = 'network_update',
    BOXSE_IP_ALLOC_ERROR = 'boxse_ip_alloc_error',
    BOXSE_PORT_FWD_ERROR = 'boxse_port_fwd_error',
    BOTNET = 'botnet',
    NETWORK_ANOMALY = 'network_anomaly',
    CERTIFICATE = 'certificate',
    MALWARE = 'malware',
    EXPLOIT = 'exploit',
    RANSOMWARE = 'ransomware',
    MALICIOUS_PROCESSES = 'malicious_processes',
    MALICIOUS_PROCESS = 'malicious_process',
    MALICIOUS_FILE = 'malicious_file',
    MALICIOUS_APPS = 'malicious_apps',
    MALICIOUS_APP = 'malicious_app',
    MALICIOUS_URL = 'malicious_url',
    PRIVACY_THREAT = 'privacy_threat',
    BOX_UPDATE_FINISHED = 'box_update_finished',
    NEW_DEVICE = 'new_device',
    STATIC_IP_ALLOCATION_ERROR = 'static_ip_allocation_error',
    PORT_FWD_ERROR = 'port_fwd_error',
    VULNERABILITY_REPORT = 'vulnerability_report'
}

export enum NotificationsSubtypes {
    BMS = 'bms',
    NEED_MORE_TIME = 'need_more_time',
    MALICIOUS_HOST_BMS = 'malicious_host_bms',
    NEW_UPDATE_AVAILABLE = 'new_update_available',
    DOS_OUTGOING = 'dos_outgoing',
    CL_SYSTEM_EXPLOIT = 'cl_system_exploit',
    CL_LOGIN_EXPLOIT = 'cl_login_exploit',
    CL_GENERIC_EXPLOIT = 'cl_generic_exploit',
    CL_TRAVERSAL_EXPLOIT = 'cl_traversal_exploit',
    CL_SQL_EXPLOIT = 'cl_sql_exploit',
    CL_CMD_EXPLOIT = 'cl_cmd_exploit',
    CL_EXTENSION_EXPLOIT = 'cl_extension_exploit',
    CL_CRITICAL_EXPLOIT = 'cl_critical_exploit',
    CL_BRUTEFORCE_ATTACK = 'cl_bruteforce_attack',
    CL_LFI_ATTACK = 'cl_lfi_attack',
    CL_LOGIN_PRIVACY = 'cl_login_privacy',
    CL_DATA_PRIVACY = 'cl_data_privacy',
    CL_BANKING_PRIVACY = 'cl_banking_privacy',
    CL_PASSWORD_PRIVACY = 'cl_password_privacy',
    NEW_ISSUES = 'new_issues',
    CL_GENERIC_TROJAN = 'cl_generic_trojan',
    CL_GENERIC_BOT = 'cl_generic_bot',
    NEW_DEVICE_PROTECTED = 'new_device_protected',
    SECONDARY_DEVICE_PROTECTED = 'secondary_device_protected',
    GUEST_USER = 'guest_user',
    SOURCE_USER = 'source_user',
    WEB_ALERT_EXPLOIT = 'web_alert_exploit',
    DEVICE_LOCATE_FAILED = 'device_locate_failed',
    DEVICE_LOCATED_NO_ADDRESS = 'device_located_no_address',
    DEVICE_LOCATED = 'device_located',
    WIPE_SUCCESS = 'wipe_success',
    WIPE_FAILED = 'wipe_failed',
    UNLOCK_APP_ATTEMPT = 'unlock_app_attempt',
    UNLOCK_DEVICE_ATTEMPT = 'unlock_device_attempt',
    LOCK_SUCCESS = 'lock_success',
    LOCK_FAILED = 'lock_failed',
    DANGEROUS_URL = 'dangerous_url',
    BOXSE_DHCP_NOTIFICATION_VENDOR = 'boxse_dhcp_notification_vendor',
    WIFI_RESET = 'wifi_reset',
    BOXSE_IP_ALLOC_ERROR = 'boxse_ip_alloc_error',
    BOXSE_PORT_FWD_ERROR = 'boxse_port_fwd_error',
    BOTNET = 'botnet',
    NETWORK_ANOMALY = 'network_anomaly',
    CERTIFICATE_WRONG_HOST = 'certificate_wrong_host',
    CIPHER_SUITE_INSECURE = 'cipher_suite_insecure',
    KEY_EXCHANGE_INSECURE = 'key_exchange_insecure',
    UNSAFE = 'unsafe',
    CERTIFICATE_EXPIRED = 'certificate_expired',
    UNTRUSTED = 'untrusted',
    WRONG_HOST = 'wrong_host',
    SELF_SIGNED = 'self_signed',
    EXPIRED = 'expired',
    ERROR = 'error',
    REVOKED = 'revoked',
    TROJAN = 'trojan',
    METASPLOIT = 'metasploit',
    LFI_ATTACK = 'lfi_attack',
    EXPLOIT_ATTACK = 'exploit_attack',
    AUTH_BYPASS = 'auth_bypass',
    DOS_INCOMING = 'dos_incoming',
    IP_REPUTATION_OUTGOING = 'ip_reputation_outgoing',
    IP_REPUTATION_INCOMING = 'ip_reputation_incoming',
    BRUTE_FORCE_ATTACK = 'brute_force_attack',
    SCANNING_ATTACK = 'scanning_attack',
    EXPLOIT = 'exploit',
    RANSOMWARE = 'ransomware',
    MALICIOUS_PROCESSES = 'malicious_processes',
    MALICIOUS_PROCESS = 'malicious_process',
    MALICIOUS_FILE = 'malicious_file',
    MALICIOUS_APPS = 'malicious_apps',
    MALICIOUS_APP = 'malicious_app',
    MALICIOUS_URL = 'malicious_url',
    BOXSE_NEW_DEVICE = 'boxse_new_device',
    AUTH_PRIVACY = 'auth_privacy',
    BANKING_PRIVACY = 'banking_privacy',
    APPLICATION_UPDATED = 'application_updated',
    DEFAULT = 'default',
    VA_SCAN_RESULT_SAFE = 'va_scan_result_safe',
    VA_SCAN_STATUS = 'va_scan_status',
    VA_SCAN_STATUS_SINGLE = 'va_scan_status_single',
    VA_NETWORK_SCAN_SINGLE_RISK = 'va_network_scan_single_risk',
    VA_NETWORK_SCAN_MULTI_RISK = 'va_network_scan_multi_risk',
    VA_NETWORK_SCAN_CLEAN = 'va_network_scan_clean',
    DEVICE_ADMIN_DISABLED = 'device_admin_disabled',
    DEVICE_ADMIN_DISABLED_ATTEMPT = 'device_admin_disabled_attempt',
    BLOCKED_APP = 'blocked_app',
    APP_UNINSTALLED = 'app_uninstalled',
    ENTER_RESTRICTED_AREA = 'enter_restricted_area',
    SAFE_CHECKIN = 'safe_checkin'
}

export enum PrivacyEventsTypes {
    IMPERSONATION = 'impersonation',
    BREACH = 'breach',
    RECORD = 'record',
    CREATE = 'create',
    ISSUE_ADDED = 'issue_added',
    SET_ACTION_STATUS = 'set_action_status',
    ADD_INFO = 'add_info',
    INIT = 'init',
    CLOUD_INIT = 'cloud_init',
    ISSUE_DONE = 'issue_done',
    DEFAULT = 'default',
    REMOVE = 'remove',
    UPDATE = 'update',
    LINK = 'link',
    UNLINK = 'unlink'
}

export enum PrivacyDescTypes {
    BREACH_WITH_NO_HELP_LINK_STANDARD = 'breachWithNoHelpLinkStandard',
    DATA_COLLECTION_WITH_NO_HELP_LINK = 'dataCollectionWithNoHelpLink'
}

export enum PrivacyEventsSubtypes {
    DEFAULT = 'default',
    FULLNAME = 'fullname',
    EMAILS = 'emails',
    PHONES = 'phones',
}

export const EventIcons = {
    TROPHY: {type: 'feature', value: 'cup'},
    SHIELD_UNPROTECTED: {type: 'feedback', value: 'shield-x'}
}

export enum EventPalceholders {
    PARENTAL_PRODUCT_NAME = 'parentalProductName',
    TS_PRODUCT_NAME = 'tsProductName',
    MANUFACTURER_NAME = 'manufacturerName',
    SOURCE_APPLICATION_NAME = 'sourceApplicationName',
    APPLICATION_NAME = 'applicationName',
    ATTACK_SOURCE = 'attackSource',
    BLOCKED_APPLICATION_NAME = 'blockedApplicationName',
    BLOCKED_APPLICATION = 'blockedApplication',
    BLOCKED_FILE = 'blockedFile',
    BLOCKED_INTEREST_NAME = 'blockedInterestName',
    BLOCKED_IP = 'blockedIp',
    BLOCKED_PROCESS = 'blockedProcess',
    BLOCKED_URL = 'blockedUrl',
    BOX_NAME = 'boxName',
    CHILD_NAME = 'childName',
    CLEAN_URL = 'cleanUrl',
    DEVICE_NAME = 'deviceName',
    DISPLAY_NAME = 'displayName',
    DOMAIN = 'domain',
    EXTERNAL_IP = 'externalIp',
    EXTERNAL_PORT = 'externalPort',
    FILENAME = 'fileName',
    HOST = 'host',
    IP = 'ip',
    LATEST_VERSION = 'latestVersion',
    LOCAL_PORT = 'localPort',
    LOCATION = 'location',
    MALWARE = 'malware',
    NAME = 'name',
    NUMBER_FRIENDS = 'numberFriends',
    NUMBER_DEVICES = 'numberDevices',
    PORT = 'port',
    PROTOCOL = 'protocol',
    REWARD = 'reward',
    STATUS = 'status',
    TARGET_IP = 'targetIp',
    THREAT_NAME = 'threatName',
    THREAT_TYPE = 'threatType',
    THREATS_COUNT = 'threatsCount',
    TIMESTAMP = 'timestamp',
    NUMBER_VULNERABILITIES = 'numberVulnerabilities',
    URL = 'url',
    VENDOR = 'vendor',
    VERSION = 'version',
    PHONE = 'phone',
    EMAIL = 'email',
    DATA_BREACH = 'dataBreach',
    WEBSITE = 'website',
    PRODUCT_NAME = 'productName',
    FULLNAME = 'fullname',
    INFORMATION = 'information',
    AGE = 'age',
    ACTION_SERVICE = 'actionService',
    LIKELIHOOD = 'likelihood',
    IMPACT = 'impact',
    AVERAGE = 'average'
}